/**************************************************************************************************************************************************
*   MODULE NAME     :  CreateAbstract
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  13-01-2021
*   DESCRIPTION     :  All Positive workflows logic(Abstract Add and update form field)
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG2467262
*   DESCRIPTION: <GLSD>: Node 20 Upgrade and Implement MSAL
*   DATE: 29-Jan-2025
/**************************************************************************************************************************************************/
import React, { Component, useContext } from 'react';
import { Container, Row, Col, Form, Button, InputGroup, Accordion, Card } from "react-bootstrap";
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import { FaSearch, FaCheckCircle, FaChevronDown, FaSpinner } from "react-icons/fa";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import Select from "react-select";
import swal from "sweetalert";
import * as MessagePool from '../../common/MessagesPool';
import { DOCUMENT_SITE_ORIGIN, SITE_PROCESSING_DOCUMENT, STATUS } from "../../../constants/constants";
import "./CreateAbstract.css";
import config from "../../../config.json";
import ToggleSwitch from "../../common/toggleSwitch/ToggleSwitch";
import EllipsisModal from "../Common/EllipsisModal";
import SearchAbstractModal from "../Common/SearchAbstractModal";
import MyDatePicker from "../../common/datePicker/MyDatePicker";
import { VALIDATION_OBJ } from "../Common/AbstractFormValidation";
import { yyyymmddFormat } from "../../common/DateFormat";
import * as Helper from "../Common/abstractHelper";
import { AuthProvider } from "../../../auth/index"
import {
    loadAllProduct,
    loadAllCountry,
    loadAllExplanation,
    loadAllStatus,
    addAbstract,
    uploadAbstractAttachment,
    addOrUpdateAbstractAttachment
} from "../../../actions/abstractActions";
import { Message } from 'semantic-ui-react';

class CreateAbstract extends Component {
    constructor(props) {
        super(props);

        this.abstractDateFields = {
            dateRecordReceived: null,
            dateTranslationRequested: null,
            dateArticleOrdered: null,
            dateTranslationReceived: null,
            dateArticleOrdered2: null,
            dateAbstractValid: null,
            dateArticleReceived: null,
            dateArticleValid: null,
            dateAbstractReviewed: null,
            dateFlwUpReceived: null,
            dateArticleReviewed: null,
            dateClosed: null,
            dateTranslationValid: null,
            lockByDate: null
        }

        this.abstractFormInitialState = {
            originalAbstractId: null,
            title: '',
            originalTitle: '',
            authors: '',
            receivedFrom: '',
            source: '',
            productId: null,
            institution: '',
            caseIds: '',
            countryId: null,
            abstract: '',
            notes: '',
            keywords: '',
            documentSiteOrigin: true,
            siteProcessingDocument: '',
            urlToOvid: '',
            explanationId: null,
            urlToSourceDb: '',
            abstractLanguage: '',
            statusId: null,
            otherStatus: '',
            caseManagerId1: null,
            caseManagerId2: null,
            caseManagerId3: null,
            ...this.abstractDateFields
        }

        this.state = {
            abstractForm: this.abstractFormInitialState,
            filesToUpload: [],
            action: '',
            isFormValid: false,
            redirect: false,
            isPrimaryDetailsValid: false,
            isSecondaryDetailsValid: false,
            isDateDetailsValid: false,
            showEllipsisModal: false,
            showSearchAbstractModal: false,
            originalAbstractTitle: '',
            modalData: '',
            productList: this.props.productData,
            statusList: this.props.statusData,
            explanationList: this.props.explanationData,
            countryList: this.props.countryData,
            caseManagerList: Helper.getFormattedCaseManagerList(this.props.loggedUserDetail),
            accordionExpandFlag: false,
            accordionTabs: {
                event_key_0: true,
                event_key_1: true,
                event_key_2: true,
            },
        }
    }

    /**
    * Function to hide/show loader.
    * @param isLoading whether to hide or show loader
    */
    setLoader = isLoading => this.setState({ isLoading });

    /**
     * Function to initiate life cycle hooks.
     */
    async componentDidMount() {
        this.setLoader(true);
        try {
            await Promise.all([
                this.loadAllProduct(),
                this.loadAllCountry(),
                this.loadAllExplanation(),
                this.loadAllStatus()
            ]);
            // Reset Form Validation to initial state
            VALIDATION_OBJ.resetFormValidation();
            let currDate = new Date();
            currDate.setHours(0,0,0,0);
            this.handleDateChange('dateRecordReceived', currDate);
            this.setLoader(false);
        } catch (e) {
            this.setLoader(false);
        }


    }

    loadAllProduct = async () => {
        let arr = this.state.productList;
        if (!(this.state.productList && this.state.productList.length > 0)) {
            let response = await this.props.loadAllProduct();
            arr = response.data.result
        }
        let resultData = Helper.getFormattedMasterData(arr).sort((a,b) => a.label.localeCompare(b.label));
        this.setState({
            productList: resultData
        });
    }

    loadAllCountry = async () => {
        let arr = this.state.countryList;
        if (!(this.state.countryList && this.state.countryList.length > 0)) {
            let response = await this.props.loadAllCountry();
            arr = response.data.result
        }
        let resultData = Helper.getFormattedMasterData(arr).sort((a,b) => a.label.localeCompare(b.label));
        this.setState({
            countryList: resultData
        });
    }

    loadAllExplanation = async () => {
        let arr = this.state.explanationList;
        if (!(this.state.explanationList && this.state.explanationList.length > 0)) {
            let response = await this.props.loadAllExplanation();
            arr = response.data.result
        }
        let resultData = Helper.getFormattedMasterData(arr).sort((a,b) => a.label.localeCompare(b.label));
        this.setState({
            explanationList: resultData
        });
    }

    loadAllStatus = async () => {
        let arr = this.state.statusList;
        if (!(this.state.statusList && this.state.statusList.length > 0)) {
            let response = await this.props.loadAllStatus();
            arr = response.data.result
        }
        let resultData = Helper.getFormattedMasterData(arr);
        let filteredStatusData = resultData.filter(el => ![STATUS.NEW, STATUS.DUPLICATE].includes(el.value)).sort((a,b) => a.label.localeCompare(b.label))
        this.setState({
            statusList: filteredStatusData
        });
    }

    /**
     * Function to handle change
     */
    handleInputChange = (event) => {
        let identifier = event.target.name;
        let value = event.target.value;
        this._validateForm(identifier, value);
    }


    /**
     * Function to validate the Form
     * @param {*} identifier
     * @param {*} value
     */

    _validateForm = (identifier, value, updOptionalData = {}) => {
        let updForm = { ...this.state.abstractForm }
        updForm[identifier] = value;
        VALIDATION_OBJ.init(updForm);

        if (VALIDATION_OBJ[identifier].shouldValidate === true) {
            VALIDATION_OBJ.applyValidation(identifier, value);
        }
        // Reset Original Abstract Field on Status Change
        if (identifier === 'statusId') {
            updForm['originalAbstractId'] = null;
            updForm['explanationId'] = null;
            VALIDATION_OBJ.applyValidation('explanationId', null);
            let statusId = value ? value.value : null;
            if (statusId) {
                updOptionalData['explanationList'] = Helper.getExplanationListByStatus(this.state.explanationList, statusId);
            }
            updOptionalData.originalAbstractTitle = '';
        }
        let formValidityResult = VALIDATION_OBJ.checkFormValidity();
        this.setState({
            ...this.state,
            ...updOptionalData,
            ...formValidityResult,
            showEllipsisModal: false,
            abstractForm: updForm
        });
    }

    /**
     * Function to handle the Dropdown onChange event
     * @param {*} identifier
     * @param {*} valueObj
     */
    handleSelectChange = (identifier, value) => {
        this._validateForm(identifier, value)
    }

    /**
     * Function to handle the onDateChange event
     * @param {*} identifier
     * @param {*} value
     */
    handleDateChange = (identifier, value) => {
        this._validateForm(identifier, value);
    }

    onChangeHandler = event => {
        if (event.target.files && event.target.files[0]) {
            let fileName = event.target.files[0].name;
            var reader = new FileReader();

            reader.readAsDataURL(event.target.files[0]); // read file as data url

            reader.onload = (evt) => { // called once readAsDataURL is completed
                this.setState({
                    ...this.state,
                    file: {
                        name: fileName,
                        dataUrl: evt.target.result
                    }
                })
            }
        }
    }

    /**
     * Function to handle Switch events
    **/
    handleSwitch = ev => {
        this.setState({
            ...this.state,
            abstractForm: {
                ...this.state.abstractForm,
                documentSiteOrigin: ev.target.checked
            }
        })
    }

    handleSubmitFunction = async (e) => {
        e.preventDefault();
        try {
            const formData = { ...this.state.abstractForm };
            if(formData.statusId !== STATUS.LINKED) {
                let res = await swal({
                    title: "Are you sure ?",
                    text: MessagePool.DUPLICATE_ABSTRACT_SAVING,
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                });
                if (!res) {
                    return false;
                }
            }
            formData.documentSiteOrigin = formData.documentSiteOrigin === true ? DOCUMENT_SITE_ORIGIN.GLOBAL : DOCUMENT_SITE_ORIGIN.JAPAN;

            // Format date details fields DATE
            let dateRecordReceived = formData.dateRecordReceived;
            let dateFieldsCheckArr = [];
            let dayDifference = function(d1, d2) {
                var t2 = d2.getTime();
                var t1 = d1.getTime();

                return parseInt((t2-t1)/(24*3600*1000));
            }
            Object.keys(this.abstractDateFields).forEach(el => {
                if (formData[el] && el !== 'dateRecordReceived' && dayDifference(formData[el], dateRecordReceived) >= 1) {
                    dateFieldsCheckArr.push(el);
                }
                formData[el] = formData[el] ? yyyymmddFormat(formData[el]) : null;
            });

            // Array of form dropdown field names
            const formDropDownFields = ['productId', 'countryId', 'explanationId', 'statusId', 'siteProcessingDocument', 'caseManagerId1', 'caseManagerId2', 'caseManagerId3']
            formDropDownFields.forEach(el => {
                formData[el] = formData[el] ? formData[el].value : null;
            })

            // Set default SiteOfProcessing based on DocumentSiteOrigin
            if (!formData.siteProcessingDocument) {
                formData.siteProcessingDocument = formData.documentSiteOrigin === DOCUMENT_SITE_ORIGIN.GLOBAL ? DOCUMENT_SITE_ORIGIN.GLOBAL : DOCUMENT_SITE_ORIGIN.JAPAN;
            }

            // Trim the values
            Object.entries(formData).forEach(data => {
                const [key, value] = data;
                if (typeof value === 'string') {
                    formData[key] = value.trim();
                }
            })

            let datesConfirmationResp = true;
            if (dateFieldsCheckArr.length > 0) {
                let dateFieldNames = Helper.formatDateFieldsArrayToString(dateFieldsCheckArr);
                datesConfirmationResp = await swal({
                    title: "Are you sure?",
                    text: MessagePool.ABSTRACT_DATES_CHECK_CONFIRMATION.replace('{dateFieldNames}', dateFieldNames),
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                })
                    .then((result) => {
                        if (result) {
                            return true
                        } else {
                            return false;
                        }
                    });
            }

            if (!datesConfirmationResp) {
                return false;
            }

            formData['keywords'] = Helper.formatKeywords(formData.keywords);
            this.setLoader(true);
            let response = await this.props.addAbstract(formData);

            if (response.status === 200) {
                let abstractId = response.data.result.abstractId;

                let attachmentResponse = await this.saveFileAttachments(abstractId);
                if (!attachmentResponse.ok) {
                    swal('', attachmentResponse.message, 'error').then(res => {
                        swal('', MessagePool.ADD_ABSTRACT_SUCCESS, 'success').then(res => {
                            this.props.history.push('/abstracts');
                        });
                    });
                } else {
                    swal('', MessagePool.ADD_ABSTRACT_SUCCESS, 'success').then(res => {
                        this.props.history.push('/abstracts');
                    });
                }
            } else {
                this.setLoader(false);
                swal('Oops!', MessagePool.SERVER_ERROR, 'error');
            }

        } catch (err) {
            this.setLoader(false);
        }
    }

    saveFileAttachments = async (abstractId) => {
        let { filesToUpload } = this.state;
        let returnObj = { ok: true }
        const config = {
            clientId: '0545c53a-54e3-4810-8a25-f1efc1a1fa75',
            openIdCallback: encodeURI('/auth/callback'),
            isGatewayScopeRequired: true,
            gatewayScopeType: 'non_production',
            logLevel: 'INFO',
          }
          // Initialize authProvider for authentication
        let authProvider = new AuthProvider(config);
        const openidAccessToken = await authProvider.getGatewayAccessToken();
        let idToken = openidAccessToken.accessToken;
        if (filesToUpload.length > 0) {
            let formData = new FormData();
            console.log(sessionStorage)
            filesToUpload.forEach((file) => {
                if (file.active) {
                    formData.append("file", file);
                    formData.append("filePath", `attachment/${abstractId}/${file.name}`);
                }
            });

            try {
                let uploadResp = await this.props.uploadAbstractAttachment(formData);

                if (uploadResp.status !== 200) {
                    returnObj = {
                        ok: false,
                        message: MessagePool.CREATE_ABSTRACT_FILE_UPLOAD_FAILED_ERROR
                    }
                    uploadResp.data = filesToUpload.map((f) => f.name);
                }

                if (uploadResp.data.length > 0) {
                    uploadResp.data.forEach((filename) => {
                        filesToUpload.forEach((x, i) => {
                            if (x.name === filename) {
                                filesToUpload.splice(i, 1);
                            }
                        });
                    });
                }
            } catch (err) {
                returnObj = {
                    ok: false,
                    message: MessagePool.CREATE_ABSTRACT_FILE_UPLOAD_FAILED_ERROR
                }
            }
        }

        if (filesToUpload.length > 0) {
            // Reiterate filesToUpload variable to set attachment, abstractId, for new uploaded files
            let fileAttachment = []
            filesToUpload.forEach((x) => {
                if (x.active) {
                    let obj = {};
                    obj.abstractAttachmentId = null;
                    obj.abstractId = abstractId;
                    obj.attachmentName = x.name;
                    obj.attachment = `attachment/${abstractId}/${x.name}`;
                    obj.active = true;
                    fileAttachment.push(obj);
                }
            });
            let payload = { fileAttachment };
            try {
                let res = await this.props.addOrUpdateAbstractAttachment(payload);
            } catch (err) {
                returnObj = {
                    ok: false,
                    message: "Database Error Occured While saving the attachments."
                }
            }
        }
        return returnObj;
    };

    handleResetFunction = async () => {
        let res = await swal({
            title: "Are you sure ?",
            text: MessagePool.ABSTRACT_DETAIL_RESET_CONFIRMATION,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        });
        if (!res) {
            return false;
        }
        VALIDATION_OBJ.resetFormValidation();
        this.setState({
            ...this.state,
            isPrimaryDetailsValid: false,
            isSecondaryDetailsValid: false,
            isDateDetailsValid: false,
            isFormValid: false,
            abstractForm: {
                ...this.state.abstractForm,
                ...this.abstractFormInitialState
            },
            filesToUpload: []
        });

    }

    openEllipsisModal = (eleLabel, eleName) => {
        const eleValue = this.state.abstractForm[eleName]
        let modalData = { eleLabel, eleName, eleValue }
        this.setState({
            ...this.state,
            showEllipsisModal: true,
            modalData
        })
    }

    openSearchAbstractModal = () => {
        this.setState({
            ...this.state,
            showSearchAbstractModal: true
        })
    }

    /**
     * This function is common for Ellipsis & Search Abstract Modal to HIDE the Modal
     * @param {*} modalName
     */
    hideModal = (modalName) => {
        this.setState({
            ...this.state,
            [modalName]: !this.state[modalName]
        })
    }

    handleOkEllipsisModal = (data) => {
        let identifier = data.eleName;
        let value = data.eleValue;
        if (identifier === 'caseIds') {
            value = Helper.getFormattedCaseIds(value);
        }
        this._validateForm(identifier, value);
    }

    /**
     * originalAbstractData receieves object { originalAbstractId, originAbstractTitle} form Search Modal
     * @param {*} originalAbstractData
     */
    handleOkSearchAbstractModal = (originalAbstractData) => {
        let identifier = "originalAbstractId";
        let value = originalAbstractData.originalAbstractId;
        let updateOptionalStateData = {
            showSearchAbstractModal: false,
            originalAbstractTitle: originalAbstractData.originalAbstractTitle
        }
        this._validateForm(identifier, value, updateOptionalStateData);
    }

    handleClick = (eventKey) => {
        this.setState({
            ...this.state,
            accordionTabs: {
                ...this.state.accordionTabs,
                [`event_key_${eventKey}`]: !this.state.accordionTabs[`event_key_${eventKey}`]
            }
        }, () => {
            const { accordionTabs: { event_key_0, event_key_1, event_key_2 } } = this.state;
            this.setState({
                ...this.state,
                accordionExpandFlag: event_key_0 === true ? false :
                    event_key_1 === true ? false :
                        event_key_2 === true ? false :
                            event_key_0 === false ? true :
                                event_key_1 === false ? true :
                                    event_key_2 === false ? true : this.state.accordionExpandFlag
            })
        })
    }

    //** Accordion Button Collapse -and expand */
    ContextAwareToggle = ({ children, eventKey, callback }) => {
        const currentEventKey = useContext(AccordionContext);
        const decoratedOnClick = useAccordionToggle(
            eventKey,
            () => callback && callback(eventKey),
        );
        const isCurrentEventKey = currentEventKey === eventKey;
        return (
            <button
                type="button"
                className="float-right"
                style={
                    {
                        backgroundColor: "transparent",
                        border: "none",
                        color: 'white',
                        transform: !isCurrentEventKey ? 'rotate(0deg)' : 'rotate(180deg)',
                    }}
                onClick={decoratedOnClick}
            >
                {children}
            </button>
        );
    }

    handleExpandCollapseAll = (flag) => {
        this.setState({
            ...this.state,
            accordionExpandFlag: !flag,
            accordionTabs: {
                ...this.state.accordionTabs,
                event_key_0: flag,
                event_key_1: flag,
                event_key_2: flag,
            }
        })
    }

    handleFileChange = async (event) => {

        let files = event.target.files;
        let newFilesArr = [...files];
        let { filesToUpload } = this.state;

        let countFiles = filesToUpload.length + newFilesArr.length;
        if (countFiles > 30) {
            swal("Oops!!", MessagePool.ABSTRACT_MAX_FILES_ERROR, "error");
            return false;
        }

        let fileValidation = VALIDATION_OBJ.validateFiles(newFilesArr);
        if (fileValidation.totalInvalidFileNames.length > 0) {
            //Remove invalid files from Upload Array
            fileValidation.totalInvalidFileNames.forEach(errFileName => {
                newFilesArr = newFilesArr.filter(f => f.name !== errFileName);
            })
        }

        let newFilesToUpload = [];
        let alreadyUploadedFiles = [];
        newFilesArr.forEach((file) => {
            let isFileExist = filesToUpload.filter(
                (x) => x.name === file.name
            );
            if (isFileExist.length > 0) {
                alreadyUploadedFiles.push(file.name);
            }

            if (isFileExist.length < 1) {
                file.active = true;
                newFilesToUpload.push(file);
            };
        });

        if (fileValidation.totalInvalidFileNames.length > 0) {
            swal('', MessagePool.ABSTRACT_INVALID_FILES_ERROR.replace('{invalidFiles}', fileValidation.totalInvalidFileNames.join(', ')), 'error').then((v) => {
                if (alreadyUploadedFiles.length > 0) {
                    swal('', MessagePool.ABSTRACT_FILE_EXISTS_ALERT.replace('{fileNames}', alreadyUploadedFiles.join(', ')), "warning");
                }
            });
        } else {
            if (alreadyUploadedFiles.length > 0) {
                swal('', MessagePool.ABSTRACT_FILE_EXISTS_ALERT.replace('{fileNames}', alreadyUploadedFiles.join(', ')), "warning");
            }
        }

        filesToUpload = filesToUpload.concat(newFilesToUpload);

        this.setState({
            ...this.state,
            filesToUpload
        });
    };

    handleAttachmentCheckboxChange = (obj) => {
        let { filesToUpload } = this.state;
        filesToUpload = filesToUpload.map((x) => {
            if (x.name === obj.name) {
                x.active = !x.active;
            }
            return x;
        });
        this.setState({
            ...this.state,
            filesToUpload,
        });
    }

    render() {

        const {
            isLoading,
            action,
            isFormValid,
            isPrimaryDetailsValid,
            isSecondaryDetailsValid,
            isDateDetailsValid,
            showEllipsisModal,
            showSearchAbstractModal,
            modalData,
            productList,
            explanationList,
            countryList,
            statusList,
            caseManagerList,
            originalAbstractTitle,
            accordionExpandFlag,
            accordionTabs: {
                event_key_0, event_key_1, event_key_2
            },
            filesToUpload
        } = this.state;

        const {
            title, originalTitle, authors, receivedFrom,
            source, productId, institution,
            caseIds, countryId, documentSiteOrigin,
            abstract, notes, keywords,
            urlToOvid, explanationId, urlToSourceDb,
            statusId, otherStatus,
            caseManagerId1, caseManagerId2, siteProcessingDocument,
            caseManagerId3, abstractLanguage,
            dateRecordReceived, dateTranslationRequested, dateArticleOrdered, dateTranslationReceived,
            dateArticleOrdered2, dateAbstractValid, dateArticleReceived, dateArticleValid,
            dateAbstractReviewed, dateFlwUpReceived, dateArticleReviewed, dateClosed,
            dateTranslationValid, lockByDate
        } = this.state.abstractForm;

        return (
            <>
                <table className="print-table">
                    <thead>
                        <tr>
                            <td>
                                <div className="page-header-space"></div>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div className="CommonWrap printPageWrap">
                                    <Container fluid>
                                        <Form autoComplete="off">
                                            <div className="headerpart">
                                                <Row>
                                                    <Col sm={7}> <h1>Create New Abstract</h1></Col>
                                                    <Col sm={5} className="text-right ">
                                                        <Button variant="primary" type="button" onClick={this.handleSubmitFunction} className="mr-2 btn btn-primary" disabled={!isFormValid} >
                                                            Save
                                                        </Button>
                                                        <Button variant="primary" type="reset" className="mr-2 btn btn-primary" onClick={this.handleResetFunction}>
                                                            Reset
                                                        </Button>
                                                        {
                                                            accordionExpandFlag ?
                                                                <Button type="button" className="btn btn-primary" onClick={() => this.handleExpandCollapseAll(true)}>Expand All</Button> :
                                                                <Button type="button" className="btn btn-primary" onClick={() => this.handleExpandCollapseAll(false)}>Collapse All</Button>
                                                        }
                                                    </Col>
                                                </Row>
                                            </div>

                                            <div className="abstractDetailForm mt-3">
                                                <Accordion activeKey={event_key_0 ? "0" : ''}>
                                                    <Card>

                                                        <Accordion.Toggle as={Card.Header} eventKey="0" onClick={(e) => this.handleClick(0)}>
                                                            Primary Details {isPrimaryDetailsValid ? <FaCheckCircle className="checkCircleD" /> : ''}
                                                            <this.ContextAwareToggle eventKey="0">
                                                                <FaChevronDown></FaChevronDown>
                                                            </this.ContextAwareToggle>
                                                        </Accordion.Toggle>


                                                        <Accordion.Collapse ref={this.accordionRef_0} eventKey="0" >
                                                            <Card.Body>
                                                                <div className="primaryDetails">
                                                                    <Row>
                                                                        <Col sm={4} className="pr-0 print-100">
                                                                            <Form.Group controlId="title">
                                                                                <Form.Label>Title<span className="mandatory">*</span>
                                                                                </Form.Label>
                                                                                <InputGroup printvalue={title}>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        name="title"
                                                                                        value={title}
                                                                                        onChange={this.handleInputChange}
                                                                                        isInvalid={VALIDATION_OBJ.title.error}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={() => this.openEllipsisModal('Title', 'title')}>...</Button>
                                                                                    </InputGroup.Append>
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.title.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>

                                                                        <Col sm={4} className="pr-0 print-100">
                                                                            <Form.Group controlId="originalTitle">
                                                                                <Form.Label>Original Title</Form.Label>
                                                                                <InputGroup printvalue={originalTitle}>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        name="originalTitle"
                                                                                        value={originalTitle}
                                                                                        onChange={this.handleInputChange}
                                                                                        isInvalid={VALIDATION_OBJ.originalTitle.error}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={() => this.openEllipsisModal('Original Title', 'originalTitle')}>...</Button>
                                                                                    </InputGroup.Append>
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.originalTitle.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>

                                                                        <Col sm={4} className="print-100">
                                                                            <Form.Group controlId="authors">
                                                                                <Form.Label>Author(s) <span className="mandatory">*</span>
                                                                                </Form.Label>
                                                                                <InputGroup printvalue={authors}>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        name="authors"
                                                                                        value={authors} onChange={this.handleInputChange}
                                                                                        isInvalid={VALIDATION_OBJ.authors.error}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={() => this.openEllipsisModal('Authors', 'authors')}>...</Button>
                                                                                    </InputGroup.Append>
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.authors.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>

                                                                    </Row>

                                                                    <Row>

                                                                        <Col sm={4} className="pr-0 print-100" >
                                                                            <Form.Group controlId="receivedFrom">
                                                                                <Form.Label>Received From <span className="mandatory">*</span>
                                                                                </Form.Label>
                                                                                <InputGroup printvalue={receivedFrom}>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        name="receivedFrom"
                                                                                        value={receivedFrom}
                                                                                        onChange={this.handleInputChange}
                                                                                        isInvalid={VALIDATION_OBJ.receivedFrom.error}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.receivedFrom.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>

                                                                        </Col>
                                                                        <Col sm={4} className="pr-0 print-100">
                                                                            <Form.Group controlId="source">
                                                                                <Form.Label>Source <span className="mandatory">*</span>
                                                                                </Form.Label>
                                                                                <InputGroup printvalue={source}>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        name="source"
                                                                                        value={source}
                                                                                        onChange={this.handleInputChange}
                                                                                        isInvalid={VALIDATION_OBJ.source.error}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={() => this.openEllipsisModal('Source', 'source')}>...</Button>
                                                                                    </InputGroup.Append>
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.source.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>

                                                                        <Col sm={4} className="print-100" >
                                                                            <Form.Group controlId="productId">
                                                                                <Form.Label> Product </Form.Label>
                                                                                <Select
                                                                                    name="productId"
                                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                    menuPortalTarget={document.body}
                                                                                    options={productList}
                                                                                    value={productId}
                                                                                    maxMenuHeight={130}
                                                                                    isClearable={true}
                                                                                    isDisabled={action === 'view' ? true : false}
                                                                                    onChange={selectedOption =>
                                                                                        this.handleSelectChange("productId", selectedOption)}

                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>

                                                                    <Row>
                                                                        <Col sm={4} className="pr-0 print-100">
                                                                            <Form.Group controlId="institution">
                                                                                <Form.Label>Institution</Form.Label>
                                                                                <InputGroup printvalue={institution}>
                                                                                    <Form.Control type="text" name="institution"
                                                                                        value={institution} onChange={this.handleInputChange}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={() => this.openEllipsisModal('Institution', 'institution')}>...</Button>
                                                                                    </InputGroup.Append>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4} className="pr-0 print-100">
                                                                            <Form.Group controlId="caseIds">
                                                                                <Form.Label>Case ID {VALIDATION_OBJ.caseIds.shouldValidate && <span className="mandatory">*</span>}</Form.Label>
                                                                                <InputGroup printvalue={caseIds}>
                                                                                    <Form.Control type="text" name="caseIds"
                                                                                        value={caseIds} onChange={this.handleInputChange}
                                                                                        isInvalid={VALIDATION_OBJ.caseIds.error}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={() => this.openEllipsisModal('Case ID', 'caseIds')}>...</Button>
                                                                                    </InputGroup.Append>
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.caseIds.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>

                                                                        <Col sm={4} className="print-100">
                                                                            <Form.Group controlId="countryId">
                                                                                <Form.Label> Country</Form.Label>
                                                                                <Select
                                                                                    name="countryId"
                                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                    menuPortalTarget={document.body}
                                                                                    options={countryList}
                                                                                    value={countryId}
                                                                                    maxMenuHeight={130}
                                                                                    isClearable={true}
                                                                                    isDisabled={action === 'view' ? true : false}
                                                                                    onChange={selectedOption =>
                                                                                        this.handleSelectChange("countryId", selectedOption)}

                                                                                />

                                                                            </Form.Group>
                                                                        </Col>

                                                                    </Row>

                                                                    <Row>
                                                                        <Col sm={4} className="pr-0 print-100">
                                                                            <Form.Group controlId="abstract">
                                                                                <Form.Label>Abstract</Form.Label>
                                                                                <InputGroup printvalue={abstract}>
                                                                                    <Form.Control as="textarea" rows="10" name="abstract"
                                                                                        onChange={this.handleInputChange} value={abstract}
                                                                                        disabled={action === "view" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button className="btnEllipsis" onClick={() => this.openEllipsisModal('Abstract', 'abstract')}>...</Button>
                                                                                    </InputGroup.Append>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4} className="pr-0 print-100" >
                                                                            <Form.Group controlId="keywords">
                                                                                <Form.Label>Keywords</Form.Label>
                                                                                <InputGroup printvalue={keywords}>
                                                                                    <Form.Control as="textarea" rows="10" name="keywords"
                                                                                        onChange={this.handleInputChange} value={keywords}
                                                                                        disabled={action === "view" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button className="btnEllipsis" onClick={() => this.openEllipsisModal('Keywords', 'keywords')}>...</Button>
                                                                                    </InputGroup.Append>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>

                                                                        <Col sm={4} className="print-100">
                                                                            <Form.Group controlId="notes">
                                                                                <Form.Label>Notes</Form.Label>
                                                                                <InputGroup printvalue={notes}>
                                                                                    <Form.Control as="textarea" rows="10" name="notes"
                                                                                        onChange={this.handleInputChange} value={notes}
                                                                                        disabled={action === "view" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button className="btnEllipsis" onClick={() => this.openEllipsisModal('Notes', 'notes')}>...</Button>
                                                                                    </InputGroup.Append>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col sm={4} className="pr-0 print-100">
                                                                            <Form.Group controlId="documentSiteOrigin">
                                                                                <Form.Label> Site of Origin</Form.Label>
                                                                                <ToggleSwitch id="documentSiteOrigin" onChange={this.handleSwitch}
                                                                                    Text={[DOCUMENT_SITE_ORIGIN.GLOBAL, DOCUMENT_SITE_ORIGIN.JAPAN]}
                                                                                    currentValue={documentSiteOrigin}
                                                                                    disabled={action === "view" || action === "edit" ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                </div>

                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                </Accordion>
                                                <Accordion activeKey={event_key_1 ? "1" : ''}>
                                                    <Card>
                                                        <Accordion.Toggle as={Card.Header} eventKey="1" onClick={(e) => this.handleClick(1)}>
                                                            Secondary Details {event_key_1} {isSecondaryDetailsValid ? <FaCheckCircle className="checkCircleD" /> : ''}
                                                            <this.ContextAwareToggle eventKey="1">
                                                                <FaChevronDown></FaChevronDown>
                                                            </this.ContextAwareToggle>
                                                        </Accordion.Toggle>

                                                        <Accordion.Collapse eventKey="1">
                                                            <Card.Body>
                                                                <div className="secondaryDetails">
                                                                    <Row>
                                                                        <Col sm={4} className="pr-0 print-100">
                                                                            <Form.Group controlId="urlToOvid">
                                                                                <Form.Label>URL to OVID/MEDLINE/JMED/JAPIC-Q
</Form.Label>
                                                                                <InputGroup printvalue={urlToOvid}>
                                                                                    <Form.Control type="text" name="urlToOvid"
                                                                                        isInvalid={VALIDATION_OBJ.urlToOvid.error}
                                                                                        value={urlToOvid} onChange={this.handleInputChange}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.urlToOvid.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4} className="print-100">
                                                                            <Form.Group controlId="urlToSourceDb">
                                                                                <Form.Label>URL to Source Database</Form.Label>
                                                                                <InputGroup printvalue={urlToSourceDb}>
                                                                                    <Form.Control type="text" name="urlToSourceDb"
                                                                                        value={urlToSourceDb} onChange={this.handleInputChange}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={() => this.openEllipsisModal('URL to Source Database', 'urlToSourceDb')}>...</Button>
                                                                                    </InputGroup.Append>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4} >
                                                                            <Form.Group controlId="abstractLanguage">
                                                                                <Form.Label>Language  </Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    name="abstractLanguage"
                                                                                    value={abstractLanguage}
                                                                                    onChange={this.handleInputChange}
                                                                                    disabled={action === "view" || action === "cancel" ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>

                                                                        <Col sm={4} className="pr-0">
                                                                            <Form.Group controlId="statusId">
                                                                                <Form.Label> Status <span className="mandatory">*</span>
                                                                                </Form.Label>
                                                                                <Select
                                                                                    name="statusId"
                                                                                    classNamePrefix="select"
                                                                                    className={VALIDATION_OBJ.statusId.error ? "reactSelect" : ""}
                                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                    menuPortalTarget={document.body}
                                                                                    options={statusList}
                                                                                    value={statusId}
                                                                                    maxMenuHeight={130}
                                                                                    isClearable={true}
                                                                                    isDisabled={action === 'view' ? true : false}
                                                                                    onChange={selectedOption =>
                                                                                        this.handleSelectChange("statusId", selectedOption)}

                                                                                >
                                                                                </Select>
                                                                                <div className={VALIDATION_OBJ.statusId.error ? "selectInvalidFeedback" : ""} >{VALIDATION_OBJ.statusId.error}</div>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4}>
                                                                            <Form.Group controlId="otherStatus">
                                                                                <Form.Label>Other Status</Form.Label>
                                                                                <InputGroup printvalue={urlToSourceDb}>
                                                                                    <Form.Control type="text" name="otherStatus"
                                                                                        value={otherStatus} onChange={this.handleInputChange}
                                                                                        isInvalid={VALIDATION_OBJ.otherStatus.error}
                                                                                        disabled={action === "view" || action === "cancel" ? true : false} />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={() => this.openEllipsisModal('Other Status', 'otherStatus')}>...</Button>
                                                                                    </InputGroup.Append>
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.otherStatus.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4} >
                                                                            <Form.Group controlId="lockByDate">
                                                                                <Form.Label>Lock By Date </Form.Label>
                                                                                <MyDatePicker
                                                                                    name='lockByDate'
                                                                                    selected={lockByDate}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                    isInvalid={!VALIDATION_OBJ.lockByDate.valid}
                                                                                    >
                                                                                        <Form.Control.Feedback type='invalid'>{VALIDATION_OBJ.lockByDate.error}</Form.Control.Feedback>
                                                                                    </MyDatePicker>
                                                                            </Form.Group>
                                                                        </Col>

                                                                    </Row>
                                                                    <Row>
                                                                        <Col sm={4} className="pr-0">
                                                                            <Form.Group controlId="originalAbstractId">
                                                                                <Form.Label>Original Abstract {VALIDATION_OBJ.originalAbstractId.shouldValidate && <span className="mandatory">*</span>}</Form.Label>
                                                                                <InputGroup printvalue={originalAbstractTitle}>
                                                                                    <Form.Control type="text" name="originalAbstractId" readOnly
                                                                                        isInvalid={VALIDATION_OBJ.originalAbstractId.error}
                                                                                        title={originalAbstractTitle}
                                                                                        value={originalAbstractTitle} onChange={this.handleInputChange}
                                                                                    />
                                                                                    <InputGroup.Append>
                                                                                        <Button onClick={this.openSearchAbstractModal} variant="primary" disabled={VALIDATION_OBJ.statusId.valid && statusId ? !([statusId.value].includes(STATUS.LINKED)) : true} ><FaSearch /></Button>
                                                                                    </InputGroup.Append>
                                                                                    <Form.Control.Feedback type="invalid">{VALIDATION_OBJ.originalAbstractId.error}</Form.Control.Feedback>
                                                                                </InputGroup>
                                                                            </Form.Group>

                                                                        </Col>
                                                                        <Col sm={4} >
                                                                            <Form.Group controlId="explanationId">
                                                                                <Form.Label>Explanation  {VALIDATION_OBJ.explanationId.shouldValidate && <span className="mandatory">*</span>}</Form.Label>
                                                                                <Select
                                                                                    name="explanationId"
                                                                                    classNamePrefix="select"
                                                                                    className={VALIDATION_OBJ.explanationId.error ? "reactSelect" : ""}
                                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                    menuPortalTarget={document.body}
                                                                                    options={explanationList}
                                                                                    value={explanationId}
                                                                                    maxMenuHeight={130}
                                                                                    isClearable={true}
                                                                                    isDisabled={action === 'view' ? true : false}
                                                                                    isOptionDisabled={(option) => option.disabled === true}
                                                                                    onChange={selectedOption =>
                                                                                        this.handleSelectChange("explanationId", selectedOption)}

                                                                                >
                                                                                </Select>
                                                                                <div className={VALIDATION_OBJ.explanationId.error ? "selectInvalidFeedback" : ""} >{VALIDATION_OBJ.explanationId.error}</div>

                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4} >
                                                                            <Form.Group controlId="siteProcessingDocument">
                                                                                <Form.Label> Site of Processing
</Form.Label>
                                                                                <Select
                                                                                    name="siteProcessingDocument"
                                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                    menuPortalTarget={document.body}
                                                                                    options={SITE_PROCESSING_DOCUMENT}
                                                                                    value={siteProcessingDocument}
                                                                                    maxMenuHeight={130}
                                                                                    isClearable={true}
                                                                                    isDisabled={action === 'view' ? true : false}
                                                                                    onChange={selectedOption =>
                                                                                        this.handleSelectChange("siteProcessingDocument", selectedOption)}

                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col sm={4} className="pr-0">
                                                                            <Form.Group controlId="caseManagerId1">
                                                                                <Form.Label>Abstract Record Screener {VALIDATION_OBJ.caseManagerId1.shouldValidate && <span className="mandatory">*</span>}</Form.Label>
                                                                                <Select
                                                                                    name="caseManagerId1"
                                                                                    classNamePrefix="select"
                                                                                    className={VALIDATION_OBJ.caseManagerId1.error ? "reactSelect" : ""}
                                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                    menuPortalTarget={document.body}
                                                                                    options={caseManagerList}
                                                                                    value={caseManagerId1}
                                                                                    maxMenuHeight={130}
                                                                                    isClearable={true}
                                                                                    isDisabled={action === 'view' ? true : false}
                                                                                    onChange={selectedOption =>
                                                                                        this.handleSelectChange("caseManagerId1", selectedOption)}
                                                                                />
                                                                                <div className={VALIDATION_OBJ.caseManagerId1.error ? "selectInvalidFeedback" : ""} >{VALIDATION_OBJ.caseManagerId1.error}</div>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4} >
                                                                            <Form.Group controlId="caseManagerId2">
                                                                                <Form.Label>Full Text Screener
</Form.Label>
                                                                                <Select
                                                                                    name="caseManagerId2"
                                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                    menuPortalTarget={document.body}
                                                                                    options={caseManagerList}
                                                                                    value={caseManagerId2}
                                                                                    maxMenuHeight={130}
                                                                                    isClearable={true}
                                                                                    isDisabled={action === 'view' ? true : false}
                                                                                    onChange={selectedOption =>
                                                                                        this.handleSelectChange("caseManagerId2", selectedOption)}

                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={4} >
                                                                            <Form.Group controlId="caseManagerId3">
                                                                                <Form.Label> Record Closer
</Form.Label>
                                                                                <Select
                                                                                    name="caseManagerId3"
                                                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                    menuPortalTarget={document.body}
                                                                                    options={caseManagerList}
                                                                                    value={caseManagerId3}
                                                                                    maxMenuHeight={130}
                                                                                    isClearable={true}
                                                                                    isDisabled={action === 'view' ? true : false}
                                                                                    onChange={selectedOption =>
                                                                                        this.handleSelectChange("caseManagerId3", selectedOption)}

                                                                                />
                                                                            </Form.Group>
                                                                        </Col>

                                                                    </Row>
                                                                    <Row>
                                                                        <Col sm={4}>
                                                                            <Form.Group controlId="fileSelect">
                                                                                <Form.Label className={`btn btn-primary mt-4 ${action === "view" || action === "cancel" ? 'disabled' : ''}`}>
                                                                                    File Attachment
                                                                                </Form.Label>
                                                                                <Form.Control
                                                                                    value=""
                                                                                    onClick={(e) =>
                                                                                        (e.target.value = null)
                                                                                    }
                                                                                    type="file"
                                                                                    isInvalid={true}
                                                                                    disabled={action === "view" || action === "cancel" ? true : false}
                                                                                    placeholder="Browse"
                                                                                    name="fileAttachment"
                                                                                    multiple={true}
                                                                                    onChange={(evt) =>
                                                                                        this.handleFileChange(evt)
                                                                                    }
                                                                                    className="fileSelectStyle"
                                                                                />
                                                                                <Form.Control.Feedback type='invalid'>{MessagePool.FILE_ATTACHMENTS_RULES_UI}</Form.Control.Feedback>

                                                                                <table className="mt-2">
                                                                                    <tbody>
                                                                                        {filesToUpload &&
                                                                                            filesToUpload.length > 0 &&
                                                                                            [...filesToUpload].map(
                                                                                                (data, index) => {
                                                                                                    return (
                                                                                                        <tr key={index}>
                                                                                                            <td>
                                                                                                                <a>
                                                                                                                    {data.name}
                                                                                                                </a>
                                                                                                            </td>
                                                                                                            <td>
                                                                                                                <Form.Check
                                                                                                                    type="checkbox"
                                                                                                                    name="attachment[]"
                                                                                                                    onChange={() => this.handleAttachmentCheckboxChange(data)}
                                                                                                                    checked={data.active}
                                                                                                                />
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    );
                                                                                                }
                                                                                            )}
                                                                                    </tbody>
                                                                                </table>
                                                                            </Form.Group>
                                                                        </Col>

                                                                    </Row>
                                                                </div>

                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                </Accordion>
                                                <Accordion activeKey={event_key_2 ? "2" : ''}>
                                                    <Card>
                                                        <Accordion.Toggle as={Card.Header} eventKey="2" onClick={(e) => this.handleClick(2)}>
                                                            Date Details {isDateDetailsValid ? <FaCheckCircle className="checkCircleD" /> : ''}
                                                            <this.ContextAwareToggle eventKey="2">
                                                                <FaChevronDown></FaChevronDown>
                                                            </this.ContextAwareToggle>
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey="2">
                                                            <Card.Body>
                                                                <div className="dateDetails">
                                                                    <Row>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateRecordReceived">
                                                                                <Form.Label>Date Record Received <span className="mandatory">*</span>
                                                                                </Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateRecordReceived'
                                                                                    selected={dateRecordReceived}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                    isInvalid={!VALIDATION_OBJ.dateRecordReceived.valid && VALIDATION_OBJ.dateRecordReceived.touched}
                                                                                >
                                                                                    <Form.Control.Feedback type='invalid'>{VALIDATION_OBJ.dateRecordReceived.error}</Form.Control.Feedback>
                                                                                </MyDatePicker>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateArticleOrdered">
                                                                                <Form.Label>Date Article Ordered</Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateArticleOrdered'
                                                                                    selected={dateArticleOrdered}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateArticleReceived">
                                                                                <Form.Label>Date Article Received </Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateArticleReceived'
                                                                                    selected={dateArticleReceived}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3} >
                                                                            <Form.Group controlId="dateAbstractValid">
                                                                                <Form.Label>Date Abstract Valid
</Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateAbstractValid'
                                                                                    selected={dateAbstractValid}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                    isInvalid={!VALIDATION_OBJ.dateAbstractValid.shouldValidate && VALIDATION_OBJ.dateAbstractValid.error}
                                                                                >
                                                                                    <Form.Control.Feedback type='invalid'>{VALIDATION_OBJ.dateAbstractValid.error}</Form.Control.Feedback>
                                                                                </MyDatePicker>
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>

                                                                    <Row>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateAbstractReviewed">
                                                                                <Form.Label>Date Record Reviewed</Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateAbstractReviewed'
                                                                                    selected={dateAbstractReviewed}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateArticleOrdered2">
                                                                                <Form.Label>Date Article Ordered 2</Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateArticleOrdered2'
                                                                                    selected={dateArticleOrdered2}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateArticleReviewed">
                                                                                <Form.Label>Date Article Reviewed  </Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateArticleReviewed'
                                                                                    selected={dateArticleReviewed}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3} >
                                                                            <Form.Group controlId="dateArticleValid">
                                                                                <Form.Label>Date Article Valid {VALIDATION_OBJ.dateArticleValid.shouldValidate && <span className="mandatory">*</span>}
                                                                                </Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateArticleValid'
                                                                                    selected={dateArticleValid}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                    isInvalid={VALIDATION_OBJ.dateArticleValid.shouldValidate && VALIDATION_OBJ.dateArticleValid.error}
                                                                                >
                                                                                    <Form.Control.Feedback type='invalid'>{VALIDATION_OBJ.dateArticleValid.error}</Form.Control.Feedback>
                                                                                </MyDatePicker>
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col sm={3}></Col>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateTranslationRequested">
                                                                                <Form.Label>Date Translation Requested</Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateTranslationRequested'
                                                                                    selected={dateTranslationRequested}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateTranslationReceived">
                                                                                <Form.Label>Date Translation Received
</Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateTranslationReceived'
                                                                                    selected={dateTranslationReceived}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3} >
                                                                            <Form.Group controlId="dateTranslationValid">
                                                                                <Form.Label>Date Translation Valid </Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateTranslationValid'
                                                                                    selected={dateTranslationValid}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>

                                                                    <Row>
                                                                        <Col sm={3}></Col>
                                                                        <Col sm={3}></Col>
                                                                        <Col sm={3} className="pr-0">
                                                                            <Form.Group controlId="dateFlwUpReceived">
                                                                                <Form.Label>Date Follow-up Received</Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateFlwUpReceived'
                                                                                    selected={dateFlwUpReceived}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col sm={3}>
                                                                            <Form.Group controlId="dateClosed">
                                                                                <Form.Label>Date Closed {VALIDATION_OBJ.dateClosed.shouldValidate && !VALIDATION_OBJ.dateClosed.validation.notRequired && <span className="mandatory">*</span>}</Form.Label>
                                                                                <MyDatePicker
                                                                                    name='dateClosed'
                                                                                    selected={dateClosed}
                                                                                    onDateChange={this.handleDateChange}
                                                                                    disabled={action === 'view' ? true : false}
                                                                                    isInvalid={VALIDATION_OBJ.dateClosed.shouldValidate && VALIDATION_OBJ.dateClosed.error}
                                                                                >
                                                                                    <Form.Control.Feedback type='invalid'>{VALIDATION_OBJ.dateClosed.error}</Form.Control.Feedback>
                                                                                </MyDatePicker>
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                </div>

                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                </Accordion>

                                                <Row className="print-hide">

                                                    <Col className="text-right mt-3">

                                                        <Button variant="primary" type="button" onClick={this.handleSubmitFunction} className="mr-2 btn btn-primary" disabled={!isFormValid}>
                                                            Save
</Button>
                                                        <Button variant="primary" type="reset" className="mr-2 btn btn-primary" onClick={this.handleResetFunction}>
                                                            Reset
</Button>


                                                    </Col>
                                                </Row>
                                            </div>
                                        </Form>
                                    </Container>
                                </div>
                                {isLoading && (
                                    <div className="loader">
                                        <FaSpinner />
                                    </div>
                                )}

                                {showEllipsisModal &&
                                    <EllipsisModal showEllipsisModal={showEllipsisModal}
                                        onHide={() => this.hideModal('showEllipsisModal')}
                                        modalData={modalData}
                                        handleOkEllipsisModal={this.handleOkEllipsisModal}
                                    />}
                                {showSearchAbstractModal &&
                                    <SearchAbstractModal showSearchAbstractModal={showSearchAbstractModal}
                                        onHide={() => this.hideModal('showSearchAbstractModal')}
                                        abstractId={null}
                                        onOk={this.handleOkSearchAbstractModal}
                                    />}
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>
                                <div className="page-footer-space"></div>
                            </td>
                        </tr>
                    </tfoot>
                </table>

            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        loggedUserDetail: state.userDataReducer.loggedUserDetail,
        productData: state.abstractDataReducer.productData,
        countryData: state.abstractDataReducer.countryData,
        statusData: state.abstractDataReducer.statusData,
        explanationData: state.abstractDataReducer.explanationData
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            loadAllProduct,
            loadAllCountry,
            loadAllExplanation,
            loadAllStatus,
            addAbstract,
            uploadAbstractAttachment,
            addOrUpdateAbstractAttachment

        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateAbstract));
